/**
 * A global namespace for `pointerdown` event.
 * @type {string}
 */
const pointerdownEvent = 'pointerdown';
export default pointerdownEvent;
